var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashbin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8199 14.8165L13.3171 14.8698L12.8199 14.8165C12.79 15.0958 12.6225 15.3901 12.296 15.6238C11.9678 15.8586 11.5198 15.9999 11.0393 15.9999H4.95989C4.47941 15.9999 4.03135 15.8586 3.7032 15.6238C3.37669 15.3901 3.20914 15.0958 3.17921 14.8165L2.2703 6.33325H13.7289L12.8199 14.8165Z",
    fill: "#212121",
    stroke: "#1A1F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9286 2.27777L10.9286 2.77778H11.4286H13.7143C13.964 2.77778 14.2094 2.81611 14.4357 2.88901C14.6621 2.96195 14.8611 3.06679 15.0236 3.19315L15.3214 2.81023L15.0236 3.19315C15.1658 3.30376 15.2756 3.42736 15.3535 3.55555H0.646389C0.723784 3.42786 0.83295 3.30476 0.97644 3.19315C1.30713 2.93595 1.77704 2.77778 2.28571 2.77778H4.57143H5.07143V2.27778C5.07143 2.13016 5.10853 1.97932 5.18673 1.83248C5.26536 1.68485 5.38552 1.54165 5.54787 1.41538L5.24339 1.0239L5.54787 1.41537C5.71033 1.28902 5.90936 1.18418 6.13576 1.11124C6.36204 1.03834 6.60743 1 6.85714 1H9.14286C9.39257 0.999998 9.63797 1.03833 9.86425 1.11123C10.0906 1.18417 10.2897 1.28901 10.4521 1.41537L10.7579 1.0222L10.4521 1.41537C10.6145 1.54164 10.7346 1.68484 10.8133 1.83247C10.8915 1.97931 10.9286 2.13015 10.9286 2.27777Z",
    fill: "#212121",
    stroke: "#1A1F36"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashbin);
export default __webpack_public_path__ + "static/media/trashbin.4c8fdc3b.svg";
export { ForwardRef as ReactComponent };